import { apiService } from '../../../../services/apiService';

export const fetchJobImportDigest = (params = {}) => {
    return apiService.postRequest('/admin/reports/job-import/digest', params);
};
